import React, { useState, useEffect } from "react";
import { useParams, Redirect } from 'react-router';
import Table from './Table';
import "../Components.css";
import { InputGroup, InputGroupAddon, Button, Input, Badge } from 'reactstrap';

export default function QuickPick(props) {
  const { token } = useParams();
  const [renderQuickPick, setRenderQuickPick] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [watchInfo, setwatchInfo] = useState([]);
  const [updateWatchDigits, setUpdateWatchDigits] = useState(0);

  const [watchCollect, setWatchCollect] = useState(false);
  const [boxCollect, setBoxCollect] = useState(false);
  const [paperCollect, setPaperCollect] = useState(false);

  const getItemInfo = async (watchigits) => {
    try {
      const response = await fetch(
        `/api/v1/SafeManagement/getInfo/${watchigits}?token=${token}`,
        // `/api/v1/SafeManagement/getInfo/${watchigits}/${token}`,
        //`/api/v1/SafeManagement/getInfo/${watchigits}`,
        {
          method: "get",
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        }
      )
      if (response.status == 401) {
        window.location.href = '/SafeManagement?authRedirect=QuickPick';
      } else if (!response.ok) {
        const payload = await response.text();
        alert(response.status + '. unsuccessful. ');
        console.log(response)
      }
      const payload = await response.json();
      console.log(payload)
      setwatchInfo(payload);
      setWatchCollect(false);
      setBoxCollect(false);
      setPaperCollect(false);

      if (response.ok) {
        // console.log("it is ok")
      }
    } catch (e) {
      console.log(e);
      alert('unsuccessful connecting');
    }
  };

  const handleWatchDigitsChange = (event) => {
    setUpdateWatchDigits(event.target.value);
  };

  useEffect(() => {
    console.log(token)
    if (token) {
      setRenderQuickPick(true)
    } else {
      redirectHandler()
    }
  }, []);


  const redirectHandler = async () => {
    try {
      const response = await fetch(
        `api/v1/SafeManagement/checkAuth`,
        {
          method: "get",
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        }
      );
      const payload = await response.json();
      console.log(payload);
      if (payload == false) {
        window.location.href = '/SafeManagement?authRedirect=QuickPick';
        setRedirect(true)
        console.log(redirect)
      }
      if (response.status === 401) {
        window.location.href = '/SafeManagement?authRedirect=QuickPick';
      } else if (!response.ok) {
        return response.text().then(text => { throw new Error(text) })
      }
    } catch (e) {
      console.log(e);
      alert('unsuccessful connecting');
    }
  };


  return (
    <>
      <div className="container">
        <div className="d-flex justify-content-between align-items-center">
        <Badge className="mb-4" variant="info">
          <h1 className="h3">Quick Pick</h1>
        </Badge>
        {console.log(token)}
        {token &&
          <a href="/SafeManagement?authRedirect=QuickPick" className="pR300px mb-3">
            <Button 
              style={{marginLeft: 'auto'}}
              outline 
              color="danger"
            >
                Log out
            </Button>
          </a>
        }
        </div>
        <div className="center pR300px">
          <InputGroup style={{ marginBottom: '20px' }}>
            <InputGroupAddon addonType="prepend">
              <Button color="secondary" style={{ cursor: 'unset' }}>Bitte Interne Nr. eingeben:</Button>
            </InputGroupAddon>
            <Input placeholder="Interne Nr."
              type="number"
              className="hideArrows"
              onChange={handleWatchDigitsChange}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  getItemInfo(updateWatchDigits)
                }
              }} />
            <InputGroupAddon addonType="append">
              <Button color="success" onClick={() => { getItemInfo(updateWatchDigits) }}>Suchen</Button>
            </InputGroupAddon>
          </InputGroup>
          {watchInfo.length !== 0 ? <Table
            watchInfo={watchInfo}
            watchDigits={updateWatchDigits}
            setWatchCollect={setWatchCollect}
            setBoxCollect={setBoxCollect}
            setPaperCollect={setPaperCollect}
            watchCollect={watchCollect}
            boxCollect={boxCollect}
            paperCollect={paperCollect}
            token={token}
          /> : ''}
        </div>
      </div>

      {redirect &&
        <Redirect to="/SafeManagement?authRedirect=QuickPick" />
      }



    </>
  );

}
